export default "__VITE_ASSET__D1t9OXHN__"